import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=59e6c573&scoped=true&"
import script from "./FooterPage.vue?vue&type=script&lang=js&"
export * from "./FooterPage.vue?vue&type=script&lang=js&"
import style0 from "./FooterPage.vue?vue&type=style&index=0&id=59e6c573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6c573",
  null
  
)

component.options.__file = "FooterPage.vue"
export default component.exports